import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { COLORS } from '../utils/colors';

interface GreetingModalProps {
  onGreetingClose: (mode: string) => void,
  showModal: boolean,
  gameNumber: number,
  greetingIcon: any,
  disableButton: boolean,
  /** Invoked when the secret click sequence completes; parent should close the modal then navigate. */
  onAdminShortcut?: () => void,
}

function GreetingModal(props: GreetingModalProps) {
  const [clickSequence, setClickSequence] = useState<string[]>([]);
  
  // Secret sequence: icon, title, icon, title, icon
  const secretSequence = ['icon', 'title', 'icon', 'title', 'icon'];
  
  const handleIconClick = () => {
    const newSequence = [...clickSequence, 'icon'];
    setClickSequence(newSequence);
    checkSecretSequence(newSequence);
  };
  
  const handleTitleClick = () => {
    const newSequence = [...clickSequence, 'title'];
    setClickSequence(newSequence);
    checkSecretSequence(newSequence);
  };
  
  const checkSecretSequence = (sequence: string[]) => {
    // Check if the last 5 clicks match the secret sequence
    if (sequence.length >= 5) {
      const lastFive = sequence.slice(-5);
      if (JSON.stringify(lastFive) === JSON.stringify(secretSequence)) {
        props.onAdminShortcut?.();
      }
    }
  };

  return (
    <Modal
    show={props.showModal}
    className='greeting-modal'
    fullscreen={true}
    animation={false}
    >
      <Modal.Body style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}>
        <img 
          src={props.greetingIcon} 
          width={100} 
          style={{borderRadius: 12, cursor: 'pointer'}} 
          alt='icon'
          onClick={handleIconClick}
        />
        <div 
          style={{fontSize: 70, fontWeight: 'bold', cursor: 'pointer'}}
          onClick={handleTitleClick}
        > 
          Puzzli 
        </div>
        <div style={{fontSize: 22}}> Swap tiles until the colors match<br/>on every shared side </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <Button 
            variant="dark"
            onClick={() => props.onGreetingClose("classic")} 
            style={{margin: 20, width: 120, backgroundColor: COLORS.BLACK, borderColor: COLORS.BLACK}}
            disabled={props.disableButton}>
            Classic
          </Button>
          <Button 
            variant="primary"
            onClick={() => props.onGreetingClose("casual")} 
            style={{marginBottom: 20, width: 120, backgroundColor: COLORS.BLUE, borderColor: COLORS.BLUE}}
            disabled={props.disableButton}>
            Casual
          </Button>
        </div>
        <div style={{fontSize: 24}}> {new Date().toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) } </div>
        <div style={{ fontSize: 18 }}>
          Game #{props.gameNumber} {props.gameNumber === 421 && '🔥'}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default GreetingModal;
